var _rect, _rect2, _rect3, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 26.667,
    fill: "#ff9933"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 26.667,
    width: 120,
    height: 26.667,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 53.334,
    width: 120,
    height: 26.666,
    fill: "#138808"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 40,
    r: 10,
    fill: "none",
    stroke: "#000080",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000080",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 33l14 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 33L53 47"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.018433e1a61b2f59f69281f5df5387a6.svg";
export { ForwardRef as ReactComponent };